<template>
  <div class="main">
    <fast-nav :show-hame-btn="false"></fast-nav>
    <!-- 图文卡片容器 -->
    <div class="card-container" id="cardContainer">
      <div class="card-item" v-for="item in gameTypeList" :key="item.id" @click="selectGameType(item.id)">
        <div class="img-wrapper">
          <img :src="website.apiURL + item.litpic" :alt="item.typename" class="card-img">
        </div>
        <div class="card-name">{{ item.typename }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import nav from '@/components/nav.vue'
import {getGameType} from '@/api/home'

export default {
  name: 'Home',
  data() {
    return {
      gameTypeList: []
    }
  },
  components: {
    'fast-nav': nav
  },
  computed: {},
  created() {
    getGameType().then(res => {
      if (res.data.status) {
        this.gameTypeList = res.data.data;
      } else {
        this.$message({
          message: '获取数据异常',
          type: 'error'
        });
        return false;
      }
    })
  },
  methods: {
    selectGameType(id){
      this.$router.push({name:'gameType',query:{'gameTypeId':id}});
    }
  }
}
</script>
<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main {
  max-width: 1200px;
  margin: 0 auto;
}


/* 容器：控制整体宽度和居中 */
.card-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  /* 电脑端：每行4列，列间距20px */
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding-top: 20px;
}

/* 图文卡片样式 */
.card-item {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  cursor: pointer;
}

/* 正方形图片容器：核心实现正方形 */
.img-wrapper {
  /* 关键：宽高比1:1（padding-top=100% 实现正方形） */
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-bottom: 1px solid #eee;
}

/* 图片样式：填充正方形容器，保持比例 */
.card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 保持图片比例，裁剪超出部分 */
  object-fit: cover;
}

/* 文字样式：居中显示，内边距 */
.card-name {
  padding: 12px 8px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式适配：手机端（屏幕宽度≤768px） */
@media (max-width: 768px) {
  .card-container {
    /* 手机端：每行2列 */
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding: 15px;
  }
}

</style>
